import { render, staticRenderFns } from "./UnsoldProducts.vue?vue&type=template&id=04cb4935"
import script from "./UnsoldProducts.vue?vue&type=script&lang=js"
export * from "./UnsoldProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports